__turbopack_context__.v({
  "partList": "vTqLFa_partList",
  "partsListContainer": "vTqLFa_partsListContainer",
});
